import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ar-virtual-earrings"
    exact
    path="/business/products/ar-virtual-earrings"
    component={AsyncPage}
  />,
  <Route
      key="/business/products/virtual-accessories"
      exact
      path="/business/products/virtual-accessories"
      component={AsyncPage}
  />,
];
